import { generateCustomPath } from "helpers/common";
import { baseApi } from "utils/axios/baseApi"
import { CLIENT_APPT_BALANCE_ADD, CLIENT_APPT_BALANCE_LIST, CLIENT_APPT_BALANCE_UPDATE } from "config/apiPaths";

const manageAppointmentBalanceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get client appointment balance
    getClientApptBalance: builder.query({
      query: ({ clientId, clientType }) => ({
        method: "GET",
        url: `${generateCustomPath(CLIENT_APPT_BALANCE_LIST, { clientId, clientType })}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: (result, error, { clientId, clientType }) => [
        { type: "ClientApptBalance", id: `${clientId}-${clientType}` }
      ]
    }),

    // save balance
    saveApptBalance: builder.mutation({
      query: ({ clientId, clientType, data }) => ({
        method: "POST",
        url: `${generateCustomPath(CLIENT_APPT_BALANCE_ADD, { clientId, clientType })}`,
        data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: (result, error, { clientId, clientType }) => [
        { type: "ClientApptBalance", id: `${clientId}-${clientType}` }
      ]
    }),

    // update balance
    updateApptBalance: builder.mutation({
      query: ({ id, clientId, clientType, data }) => ({
        method: "PUT",
        url: `${generateCustomPath(CLIENT_APPT_BALANCE_UPDATE, { id, clientId, clientType })}`,
        data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: (result, error, { clientId, clientType }) => [
        { type: "ClientApptBalance", id: `${clientId}-${clientType}` }
      ]
    }),

    // delete record
    deleteApptBalanceRecord: builder.mutation({
      query: ({ id, clientId, clientType }) => ({
        method: "DELETE",
        url: `${generateCustomPath(CLIENT_APPT_BALANCE_UPDATE, { id, clientId, clientType })}`,
      }),
      invalidatesTags: (result, error, { clientId, clientType }) => [
        { type: "ClientApptBalance", id: `${clientId}-${clientType}` }
      ]
    }),
  })
})

export const {
  useGetClientApptBalanceQuery,
  useSaveApptBalanceMutation,
  useUpdateApptBalanceMutation,
  useDeleteApptBalanceRecordMutation,
} = manageAppointmentBalanceApi